import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
    document.body.style.overflow = "auto";
  };
  }, [menuOpen]);

  return (
    <div className="navbar-container">
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}

      <div className={`menu-links ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={closeMenu}>
          <button className="nav-btn">Anasayfa</button>
        </Link>
        <Link to="/about" onClick={closeMenu}>
          <button className="nav-btn">Hakkımda</button>
        </Link>
        <Link to="/programs" onClick={closeMenu}>
          <button className="nav-btn">Çalışma Alanlarım</button>
        </Link>
        {/*<Link to="/blog" onClick={closeMenu}>*/}
          <button className="nav-btn">Blog</button>
        <Link to="/contact" onClick={closeMenu}>
          <button className="nav-btn">İletişim</button>
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
